import i18n from "i18next";
import { deDE } from "@mui/x-data-grid";
import translationEN from "./locales/en/translation";
import translationDE from "./locales/de/translation";

i18n.init({
  resources: {
    en: {
      translation: translationEN,
      name: "English",
    },
    de: {
      translation: translationDE,
      name: "Deutsch",
    },
  },
  lng: "de", // if you're using a language detector, do not define the lng option
  fallbackLng: "en",

  interpolation: {
    escapeValue: false, // react already safes from xss
  },
});

export default i18n;
// set l18n for react DataGrid components
export const reactMUILocale =
  deDE.components.MuiDataGrid.defaultProps.localeText;
